// extracted by mini-css-extract-plugin
module.exports = {"element":"_2dw6UND0WKzANIRBfVbz8I"};